<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  created() {
    localStorage.removeItem("token");
    this.$router.push("/");
  },
});
</script>

<template></template>
